import { useState } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import { FormProvider, useForm } from "react-hook-form";
import { Button, Flex, Text, useMantineTheme } from "@mantine/core";
import { TextInputControlled } from "../../../../components";
import {
  ValidationSendRecoverEmail,
  ValidationSendRecoverPhone,
} from "./schema-validation";
import {
  IRecoveryPassword,
  recoveryPassword,
} from "../../../../hooks/useAuthService";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { whitelabel_id } from "../../../../api";

interface IProps {
  nextStep: () => void;
  type: string;
  setAlreadyPassword: React.Dispatch<React.SetStateAction<boolean>>;
  setEmailHash: React.Dispatch<React.SetStateAction<string>>;
  userIp: string;
}

const SendRecover = ({
  nextStep,
  type,
  setAlreadyPassword,
  setEmailHash,
  userIp,
}: IProps) => {
  const theme = useMantineTheme();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [erro, setErro] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const methods = useForm<IRecoveryPassword>({
    mode: "all",
    resolver: yupResolver(
      type === "phone" ? ValidationSendRecoverPhone : ValidationSendRecoverEmail
    ),
    defaultValues: {
      email: "",
      // phone: "",
      client_ip: userIp,
    },
  });

  const {
    handleSubmit,
    formState: { isDirty, isValid },
  } = methods;

  const onSubmit = async (data: IRecoveryPassword) => {
    setIsLoading(true);
    setErro(null);
    if (!!whitelabel_id) {
      data.whitelabel_id = whitelabel_id;
    }
    try {
      const response = await recoveryPassword(data);

      if (!!response?.data?.data?.user_email_hash) {
        const { user_email_hash } = response.data.data;
        setEmailHash(user_email_hash);
      }

      setAlreadyPassword(true);
      nextStep();
    } catch (error: any) {
      const erro = error.status;

      if (erro === 417) {
        setErro(
          t("autenticacao.acessar_conta.forget_password.step_2.erro_417")
        );

        setTimeout(() => {
          navigate("/autenticacao/verficar-email");
        }, 2000);
      } else {
        setErro(t("autenticacao.acessar_conta.forget_password.step_2.erro"));
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Text size={16} fw={400} mb={24} maw={602} ta="center">
          {t(`autenticacao.acessar_conta.forget_password.step_2.text_${type}`)}
        </Text>
        {/* {type === "phone" ? ( */}
        {/* <InputWrapper label="Telefone" withAsterisk>
          <Controller
            name="phone"
            control={control}
            render={({ field: { onBlur, onChange, value } }) => (
              <Input<any>
                onBlur={onBlur}
                onChange={onChange}
                value={value}
                component={IMaskInput}
                mask="(00) 00000-0000"
                placeholder="(00) 00000-0000"
              />
            )}
          />
        </InputWrapper>
      ) : ( */}
        <TextInputControlled
          name="email"
          label={t("global.input.email.label")}
          placeholder={t("global.input.email.placeholder")}
          withAsterisk
        />

        {/* )} */}
        <Button
          variant="primary"
          fullWidth
          mt={26}
          onClick={handleSubmit(onSubmit)}
          disabled={!isDirty || !isValid}
          loading={isLoading}
        >
          {t("global.button.send")}
        </Button>
        {erro && <Text color="red">{erro}</Text>}
        <Flex
          w="100%"
          justify="space-between"
          mt={24}
          pt={24}
          style={{ borderTop: `1px solid ${theme.colors.other[5]}` }}
        >
          <Text>
            {t("autenticacao.acessar_conta.forget_password.step_2.have_code")}
          </Text>
          <Button
            h="auto"
            variant="link"
            onClick={() => {
              setAlreadyPassword(false);
              nextStep();
            }}
          >
            {t("global.button.click")}
          </Button>
        </Flex>
      </form>
    </FormProvider>
  );
};

export default SendRecover;
